import type React from 'react';
import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import st from './Row.module.sass';
import { Dummy } from '../cell/Dummy';

interface RowProps extends PropsWithChildren {
  title?: string;
  secondary?: boolean;
  dummySize?: number;
  borderBottom?: boolean;
}

function Row({
  title = undefined,
  children = undefined,
  secondary = false,
  dummySize = undefined,
  borderBottom = false,
}: RowProps): React.JSX.Element {
  return (
    <div
      className={classNames(st.Row, {
        [st.Row_secondary]: secondary,
        [st.Row_borderBottom]: borderBottom,
      })}
    >
      <span className={st.RowTitle}>{title}</span>
      {children}
      {!!dummySize && <Dummy size={dummySize} />}
    </div>
  );
}

export { Row };
